import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';

import withStyles from '@mui/styles/withStyles';
import Paper from '@mui/material/Paper';

import { clearTaskAccomplishmentInfo } from '../store/slices/dashboardStatsSlice';

import { isNonLocalNonLoggedInVisitor, createStdRequest, apiFetch } from '../utils/utils';

import ReduxLoader from '../store/ReduxLoader';
import DA from '../store/ReduxAccess';

import CondensedOrgFacePanel from './CondensedOrgFacePanel';
import CondensedOrgContentChooser from './CondensedOrgContentChooser';

import facePageStyles from '../assets/jss/crm/views/facePageStyles';

const condensedOrgPanelStyles = (theme) => ({
  ...facePageStyles(theme),
  radioButton: {
    padding: '8px 3px 8px 12px',
    '&>span>svg': {
      fontSize: '18px',
    },
  },
  businessTypeLabel: {
    marginBottom: '-4px',
  },
  radioDiv: {
    height: '30px',
    cursor: 'pointer',
  },
});

class CondensedOrgPanel extends React.Component {
  state = {
    loading: false,
    dummyRefreshCounter: 0,
  };

  componentDidMount() {
    this.loadRequiredData();
  }

  loadRequiredData() {
    const { visibleFirmId } = this.props;
    const completionCallback = () => {
      this.setState({ loading: false });
    };
    ReduxLoader.loadInfoForReferrerOrg(this, visibleFirmId, completionCallback);
  }

  getContactsAtReferrerOrg() {
    const visibleFirmId = this.props.visibleFirmId;
    return DA.getContactsAtVisibleFirm(visibleFirmId);
  }

  createNoteApiStruct(noteText) {
    const now = DateTime.local();
    const authorEmail = this.props.userInfo.email;
    const viewingFirmId = DA.getFirmId();
    const referrerOrgId = this.props.visibleFirmId;
    return {
      date: now.toISO(),
      authorEmail,
      viewingFirmId,
      otherFirmId: referrerOrgId,
      content: noteText,
    };
  }

  createNote(noteText) {
    const uri = '/api/note';
    const apiStruct = this.createNoteApiStruct(noteText);
    const request = createStdRequest(uri, 'POST', apiStruct);
    const actionOnGoodResponse = (json) => {
      // update Redux store
      this.props.clearTaskAccomplishmentInfo();
      ReduxLoader.addOrUpdateNotesOnFirms(json);
      // recompute and display new activity groups
      this.setState({ dummyRefreshCounter: this.state.dummyRefreshCounter + 1 });
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  render() {
    if (isNonLocalNonLoggedInVisitor()) {
      return <Redirect to="/homeDispatcher" />;
    }

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    const { classes, visibleFirmId } = this.props;
    const viewingFirmId = DA.getFirmId();
    const contacts = this.getContactsAtReferrerOrg();

    return (
      <Paper className={classes.root}>
        <CondensedOrgFacePanel visibleFirmId={visibleFirmId} contacts={contacts} />
        <CondensedOrgContentChooser
          viewingFirmId={viewingFirmId}
          visibleFirmId={visibleFirmId}
          contactsFunc={() => this.getContactsAtReferrerOrg()}
          noteCreationFunc={(noteText) => this.createNote(noteText)}
        />
      </Paper>
    );
  }
}

CondensedOrgPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});
const actionProducers = {
  clearTaskAccomplishmentInfo,
};
export default connect(mapStateToProps, actionProducers)(withStyles(condensedOrgPanelStyles)(CondensedOrgPanel));
